import { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";
import "@/assets/styles/main.scss";
import ProvideLayout from "./contexts/UseLayout";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import "animate.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-quill/dist/quill.snow.css";
import "./i18n";
import "react-confirm-alert/src/react-confirm-alert.css";
import Player from "lottie-react";
import loadingAnimation from "./assets/loading_screen.json";

import { QueryClientProvider, QueryClient } from "@tanstack/react-query";

const RoutesMain = lazy(() => import("./routes"));

const queryClient = new QueryClient();

function Splash() {
  return (
    <div className="w-screen h-screen bg-azul-400 flex justify-center items-center">
      <Player
        autoplay
        loop
        animationData={loadingAnimation}
        style={{ height: "100%", width: "100%" }}
      />
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <QueryClientProvider client={queryClient}>
    <Suspense fallback={<Splash />}>
      <ProvideLayout>
        <RoutesMain />
      </ProvideLayout>
      <ToastContainer />
    </Suspense>
  </QueryClientProvider>
);
